<template>
  <main id="content" v-if="profile">
    <flickity v-if="slides.length" id="homeSlide" ref="flickity" :options="flickityOptions" :class="{ hideArrows: slides.length == 1 }">
      <div class="slide" v-for="(slide, index) in slides" :key="index">
        <img :data-flickity-lazyload="slide.image_url" class="img">
        <div class="container">
          <div class="caption">
            <h2 v-if="slide.title">{{ slide.title }}</h2>
            <p v-if="slide.description">{{ slide.description }}</p>
            <a v-if="slide.button_action" href="javascript:;" class="btn btn-primary buttonBackgroundBorder" @click="scrollTo(slide.button_action)">{{ slide.button_text }}</a>
          </div>
        </div>
      </div>
    </flickity>
    <section id="inventory" class="pt-3 mt-1">
      <div class="container">
        <!-- Filter -->
        <div class="row">
          <div class="col-12 col-lg-auto mb-3">
            <a href="javascript:;" @click=toggleFilter class="btn btn-block btn-primary no-outline i-lg buttonBackgroundBorder">
              <i class="icon-sort mr-2"></i> {{ $t('Filtrar Resultados') }}</a>
          </div>
          <div class="col-12 col-lg-7 mb-3">
            <h2 class="title text-center mt-1">{{ $t('INVENTARIO VIRTUAL') }}</h2>
          </div>
          <form :class="{ 'filter-form' : true, animated : true, fadeOut : isFilterDisplay, fadeIn : !isFilterDisplay }">
            <div class="head buttonBackgroundBorder">
              <h3><i class="icon-sort mr-2"></i> {{ $t('filtrar') }} </h3>
              <a href="javascript:;" @click=toggleFilter class="btn"><i class="icon-close"></i></a>
            </div>
            <div class="body">
              <div class="row justify-content-between align-items-center mb-3" v-if="checkSelectedFilters">
                <div class="col-12 col-lg-auto">
                  <h5>{{ $t('Filtros Aplicados') }}</h5>
                </div>
                <div class="col-12 col-lg-auto">
                  <button type="reset" class="btn btn-sm btn-primary btn-pill buttonBackgroundBorder" @click="removeFilter('all')"><i class="icon-restart"></i> {{ $t('REINICIAR BUSQUEDA') }}</button>
                  <button type="button" class="btn btn-sm btn-primary ml-3 btn-pill buttonBackgroundBorder" @click=toggleFilter>{{ $t('VER RESULTADOS') }}</button>
                </div>
              </div>
              <ul class="applied-filters" v-if="selectedFilters !== null">
                <span v-for="(filters, index) in selectedFilters" :key="index">
                  <span v-if="index !== 'priceRange'">
                    <li v-for="(filter, singleFilterIndex) in filters" :key="singleFilterIndex" class="buttonBorder">
                      <a href="javascript:;" class="remove" @click="removeFilter(index, filter)"><span class="icon-close buttonElement"></span></a>
                      <strong>{{ index|filtersRename }}:</strong> {{ filter.name ? filter.name : filter }}
                    </li>
                  </span>
                </span>
              </ul>
              <div class="accordion">
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Precio') }}
                  </a><br><br>
                  <div class="accordion-content rangeSlider" style="display:block;">
                    <vue-slider
                    :dotStyle="{ backgroundColor: colorScheme && colorScheme.accent ? colorScheme.accent : '#c004' }"
                    :railStyle="{ backgroundColor: colorScheme && colorScheme.accent ? colorScheme.accent : '#c00' }"
                    :processStyle="{ backgroundColor: colorScheme && colorScheme.accent ? colorScheme.accent : '#c00' }"
                    :tooltipStyle="{ backgroundColor: colorScheme && colorScheme.accent ? colorScheme.accent : '#c00' }"
                    :labelStyle="{ backgroundColor: colorScheme && colorScheme.accent ? colorScheme.accent : '#c00' }"
                    v-model="selectedFilters.priceRange" :min="0" :max="100000" :lazy="true" :tooltip="'always'" :silent="true" :tooltip-formatter="formatterPrice"></vue-slider>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title" >
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Estilo') }}
                  </a>
                  <div class="accordion-content" style="display:block;">
                    <label v-for="(bodyStyle, index) in filters.bodyStyles" :key="index" class="form-check">
                      <input v-model="selectedFilters.bodyStyles" name="make" :value="bodyStyle" class="form-check-input" type="checkbox">
                      <span :class="{ buttonElement: selectedFilters.bodyStyles.includes(bodyStyle) }">{{ bodyStyle }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Millaje') }}
                  </a>
                  <div class="accordion-content" style="display:block;" v-if="filters && filters.mileages">
                    <label v-for="(mileage, index) in filters.mileages" :key="index" class="form-check">
                      <input v-model="selectedFilters.mileages" name="mileage" :value="mileage" :disabled="selectedFilters.mileages.length > 0 && selectedFilters.mileages.indexOf(mileage) === -1" class="form-check-input" type="radio">
                      <span :class="{ buttonElement: selectedFilters.mileages == mileage }">{{ mileage.name }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Marca') }}
                  </a>
                  <div class="accordion-content" style="display:block;" v-if="filters && filters.makes">
                    <label v-for="(make, index) in filters.makes" :key="index" class="form-check">
                      <input v-model="selectedFilters.makes" name="make" :value="make" class="form-check-input" type="checkbox">
                      <span :class="{ buttonElement: selectedFilters.makes.includes(make) }">{{ make }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Modelo') }}
                  </a>
                  <div class="accordion-content" style="display:block;" v-if="filters.models && selectedFilters.makes.length">
                    <label v-for="(model, index) in filters.models" :key="index" class="form-check">
                      <input v-model="selectedFilters.models" name="make" :value="model" class="form-check-input" type="checkbox">
                      <span :class="{ buttonElement: selectedFilters.models.includes(model) }">{{ model }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Condición') }}
                  </a>
                  <div class="accordion-content" style="display:block;" v-if="filters && filters.conditions">
                    <label v-for="(condition, index) in filters.conditions" :key="index" class="form-check">
                      <input v-model="selectedFilters.conditions" name="condition" :value="condition" class="form-check-input" type="checkbox" >
                      <span :class="{ buttonElement: selectedFilters.conditions.includes(condition) }">{{ $t(condition.name) }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Fotos') }}
                  </a>
                  <div class="accordion-content" style="display:block;">
                    <label v-for="(photo, index) in filters.photos" :key="index" class="form-check">
                      <input v-model="selectedFilters.photos" name="photos" :value="photo" class="form-check-input" type="checkbox">
                      <span :class="{ buttonElement: selectedFilters.photos.includes(photo) }">{{ $t(photo.name) }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Año') }}
                  </a>
                  <div class="accordion-content" style="display:block;" v-if="filters && filters.years">
                    <label v-for="(year, index) in filters.years" :key="index" class="form-check">
                      <input v-model="selectedFilters.years" name="year" :value="year" class="form-check-input" type="checkbox">
                      <span :class="{ buttonElement: selectedFilters.years.includes(year) }">{{ year }}</span>
                    </label>
                  </div>
                </div>
                <div class="accordion-item open">
                  <a href="javascript:;" class="accordion-title">
                    <i class="icon-arrow-up buttonBackgroundBorder"></i>
                    {{ $t('Transmisión') }}
                  </a>
                  <div class="accordion-content" style="display:block;" v-if="filters && filters.transmissions">
                    <label v-for="(transmission, index) in filters.transmissions" :key="index" class="form-check">
                      <input v-model="selectedFilters.transmissions" name="transmission" :value="transmission" class="form-check-input" type="checkbox">
                      <span :class="{ buttonElement: selectedFilters.transmissions.includes(transmission) }">{{ $t(transmission.name) }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- inventory -->
        <div class="row justify-content-center">
          <!-- list -->
          <div class="col-12">
            <ul class="inventory-list" v-if="vehicles">
              <li v-for="(vehicle, index) in vehicles" :key=index>
                <label class="compare" :data-tooltip="`${$t('Seleccione 2 ó 3 modelos para comparar') }.`">
                  <input v-model="selectedVehicles" :value="vehicle" name="selectedVehicles" type="checkbox" :disabled="selectedVehicles.length > 2 && selectedVehicles.indexOf(vehicle) == -1">
                  <span>{{ $t('Comparar') }}</span>
                </label>
                <div class="img-holder">
                  <img data-flickity-lazyload="/img/placeholder-vehicle.jpg" :src="`${vehicle.photos.length > 0 ? vehicle.photos[0].url : '/img/placeholder-vehicle.jpg'}`">
                </div>
                <a href="javascript:;" class="info backgroundTransparency" @click="beforeVehicleDetail(vehicle.slug)">
                  <h4 class="brand">{{ vehicle.make }} {{ vehicle.model }}</h4>
                  <h5 class="year">{{ vehicle.year }}</h5>
                  <span class="mpg"><i class="icon-mpg"></i><strong> {{ vehicle.city_miles_per_gallon }} / {{ vehicle.highway_miles_per_gallon }}</strong></span>
                  <p>{{ $t('Condición') }}: {{ vehicle.condition|condition  }}</p>
                  <p>{{ $t('Transmisión') }}: {{ vehicle.transmission_description }}</p>
                  <span :class="{ btn: true, 'btn-sm': true, buttonElement: hover }" @mouseover="hover = true" @mouseleave="hover = false">{{ $t('VER DETALLES') }}</span>
                </a>
              </li>
            </ul>
            <h3 v-if="!vehicles.length" class="text-center">{{ $t('NO SE ENCONTRARON RESULTADOS') }}</h3>
          </div>
          <!-- controls -->
          <p class="col-12 small mt-3 text-center">{{ $t('Resultados') }} : 1 {{ $t('al') }} {{ to }} {{ $t('de') }}  {{ vehiclesTotal }} {{ $t('vehículos') }}</p>
          <div class="col-12 col-md-auto" v-if="to < vehiclesTotal">
            <a href="javascript:;" @click=loadMoreVehicles class="btn btn-primary btn-block i-lg buttonBackgroundBorder"><i class="icon-more mr-2"></i> {{ $t('MÁS RESULTADOS') }}</a>
          </div>
          <div class="col-12 d-none d-lg-block">
            <a href="javascript:;" v-scroll-to="'#inventory'" class="btn btn-default btn-sm i-lg scrollTo hoverElement"><i class="icon-arrow-up mr-2"></i> {{ $t('Hacia arriba') }}</a>
          </div>
        </div>
      </div>
    </section>
    <section id="about" class="mt-3">
      <div class="container">
        <div class="row justify-content-around">
          <div class="col-12 col-md-5 col-lg-4">
            <img :src="profile.photo_url" class="user-pic">
            <ul class="social">
              <li v-for="(social, index) in profile.social_networks" :key=index><a :href="social.link" target="_blank"><i :class="`icon-${social.name} buttonElement`"></i></a></li>
            </ul>
          </div>
          <div class="col-12 col-md col-lg-7">
            <h2 class="title-sm text-uppercase">{{ $t('Sobre mí') }}</h2>
            <p v-html="profile.about_me"></p>
            <br>
            <h2 class="title-sm text-uppercase">{{ $t('INFORMACIÓN DE CONTACTO') }}</h2>
            <ul class="about-contact">
              <li><i class="icon-local-phone"></i> {{ $t('Teléfono principal') }}: <a :href="`tel:${profile.phone}`" class="cc-active hoverElement buttonElement">{{ profile.phone }}</a></li>
              <li v-if="!sharedData.isMultiDealerGroup"><i class="icon-phone"></i> {{ $t('Teléfono alterno') }}: <a :href="`tel:${sharedData.phone}`" class="cc-active hoverElement buttonElement">{{ sharedData.phone }}</a></li>
              <li><i class="icon-email"></i> {{ $t('Correo Electrónico') }}: <a :href="`mailto:${profile.email}`" class="cc-active hoverElement buttonElement">{{ profile.email }}</a>
              </li>
              <li v-if="!sharedData.isMultiDealerGroup"><i class="icon-map"></i> {{ $t('Dirección') }}: <a :href="sharedData.addressLink" target="_blank" class="cc-active hoverElement buttonElement">{{ sharedData.address }}</a></li>
            </ul>
            <a href="javascript:;" class="btn btn-primary buttonBackgroundBorder" @click="downloadVCF"><i class="icon-contact mr-2"></i> {{ $t('Descargar mi contacto') }} (.vcf)</a>
          </div>
        </div>
      </div>
    </section>
    <section id="formSection" class="mt-5">
      <div class="container p-0">
        <nav class="tabNav">
          <a href="javascript:;" :class="{ 'active': currentTabID == 'contact-tab', formElement: currentTabID == 'contact-tab'}" @click="changeTabID('contact-tab');"><i class="icon-message"></i><span>{{ $t('CONTACTAR') }}</span></a>
          <a href="javascript:;" :class="{ 'active': currentTabID == 'finance-tab', formElement: currentTabID == 'finance-tab' }" @click="changeTabID('finance-tab');"><i class="icon-finance"></i><span>{{ $t('Financiamiento').toUpperCase() }}</span></a>
          <a href="javascript:;" :class="{ 'active': currentTabID == 'trade-tab', formElement: currentTabID == 'trade-tab' }" @click="changeTabID('trade-tab');"><i class="icon-trade-in"></i><span>{{ $t('TRADE-IN') }}</span></a>
          <a href="javascript:;" :class="{ 'active': currentTabID == 'ref-tab', formElement: currentTabID == 'ref-tab' }" @click="changeTabID('ref-tab');"><i class="icon-referred"></i><span>{{ $t('REFERIDO') }}</span></a>
        </nav>
        <div class="tabsContent px-3">
          <form id="contact-tab" :class="{ tab: true, 'd-block': currentTabID == 'contact-tab' }" v-on:submit.prevent="validateForm('contactForm')" data-vv-scope="contactForm">
            <div class="row">
              <div class="col-12 mt-5 mb-4 my-md-5">
                <h3 class="title text-center">{{ $t('CONTACTAR') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Nombre').toUpperCase() }} *</label>
                <input v-model="contact.name" name="contactForm.name" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('contactForm.name')">{{ $t('El campo nombre es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Apellido').toUpperCase() }} *</label>
                <input v-model="contact.lastname" name="contactForm.lastname" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('contactForm.lastname')">{{ $t('El campo apellido es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Teléfono').toUpperCase() }} *</label>
                <masked-input v-model="contact.phone" mask="(111) 111-1111" type="tel" name="contactForm.phone" v-validate.disabled="'required'" class="form-control form-control-lg"/>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="contact.submitted && errors.has('contactForm.phone')">{{ $t('El campo teléfono es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Correo Electrónico').toUpperCase() }}</label>
                <input v-model="contact.email" name="contactForm.email" v-validate="'email'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('contactForm.email')">{{ $t('Formato incorrecto') }}</span>
              </div>
              <div class="form-group col-12 col-md-8">
                <label>{{ $t('Mensaje').toUpperCase() }}</label>
                <textarea v-model="contact.message" name="contactForm.message" class="form-control form-control-lg" rows="1"></textarea>
              </div>
              <div class="form-group col-12">
                <div class="captcha formBorder">
                  <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                  <label><input v-model="contact.human" name="contactForm.human" v-validate="'required'" type="checkbox" value="1"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                  <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('contactForm.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                </div>
              </div>
              <div class="col-12">
                <p class="text-success" v-if="contact.responseMessage">{{ $t(contact.responseMessage) }}.</p>
                <button class="btn btn-primary formBackgroundBorder"><i class="icon-send"></i> {{ $t('Enviar') }}</button>
              </div>
            </div>
          </form>

          <form id="finance-tab" :class="{ tab: true, 'd-block': currentTabID == 'finance-tab' }" v-on:submit.prevent="validateForm('financingForm')" data-vv-scope="financingForm">
            <div class="row">
              <div class="col-12 mt-5 mb-4 my-md-5">
                <h3 class="title text-center">{{ $t('Financiamiento').toUpperCase() }}</h3>
              </div>
            </div>
            <div class="row">
              <h5 class="col-12 mb-3 formElement">{{ $t('Información de contacto') }}:</h5>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Nombre').toUpperCase() }} *</label>
                <input v-model="financing.name" name="financingForm.name" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.name')">{{ $t('El campo nombre es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Apellido').toUpperCase() }} *</label>
                <input v-model="financing.lastname" name="financingForm.lastname" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.lastname')">{{ $t('El campo apellido es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Teléfono').toUpperCase() }} *</label>
                <masked-input v-model="financing.phone" mask="(111) 111-1111" type="tel" name="financingForm.phone" v-validate="'required'" class="form-control form-control-lg"/>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="financing.submitted && errors.has('financingForm.phone')">{{ $t('El campo teléfono es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Correo Electrónico').toUpperCase() }}</label>
                <input v-model="financing.email" name="financingForm.email" v-validate="'email'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.email')">{{ $t('Formato incorrecto') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('FECHA DE NACIMIENTO') }}</label>
                <input v-model="financing.date" name="financingForm.date" class="form-control form-control-lg" type="date">
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('ESTADO CIVIL') }} *</label>
                <select v-model="financing.civilStatus" name="financingForm.civilStatus" v-validate="'required'" class="form-control form-control-lg">
                  <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                  <option value="single">{{ $t('Soltero(a)') }}</option>
                  <option value="married">{{ $t('Casado(a)') }}</option>
                </select>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.civilStatus')">{{ $t('El campo estado civil es requerido') }}</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <h5 class="col-12 mb-3 formElement">{{ $t('Información de vivienda') }}:</h5>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('DIRECCIÓN') }} *</label>
                <input v-model="financing.address" name="financingForm.address" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.address')">{{ $t('El campo dirección es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('URBANIZACIÓN') }}</label>
                <input v-model="financing.urbanization" name="financingForm.urbanization" class="form-control form-control-lg" type="text">
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('CIUDAD') }} *</label>
                <input v-model="financing.city" name="financingForm.city" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.city')">{{ $t('El campo ciudad es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('CÓDIGO POSTAL') }} *</label>
                <input v-model="financing.zipcode" name="financingForm.zipcode" v-validate="'required'" maxlength="5" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.zipcode')">{{ $t('El campo código postal es requerido') }}</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <h5 class="col-12 mb-3 formElement">{{ $t('Información financiera') }}:</h5>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('TIPO DE EMPLEO') }} *</label>
                <select v-model="financing.jobType" name="financingForm.jobType" v-validate="'required'" class="form-control form-control-lg">
                  <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                  <option value="fullTime">{{ $t('Tiempo completo') }}</option>
                  <option value="partTime">{{ $t('Tiempo parcial') }}</option>
                  <option value="freelance">{{ $t('Por cuenta propia') }}</option>
                </select>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.jobType')">{{ $t('El campo tipo de empleo es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('SUELDO MENSUAL') }} *</label>
                <input v-model="financing.salary" name="financingForm.salary" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.salary')">{{ $t('El campo salario es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('DUEÑO DE RESIDENCIA') }}</label>
                <select v-model="financing.residenceType" name="financingForm.residenceType" class="form-control form-control-lg">
                  <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                  <option value="rent">{{ $t('Alquilar') }}</option>
                  <option value="owner">{{ $t('Propia') }}</option>
                  <option value="family">{{ $t('Familiar') }}</option>
                </select>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('PAGO DE RESIDENCIA') }}</label>
                <input v-model="financing.residencePayment" name="financingForm.residencePayment" class="form-control form-control-lg" type="text">
              </div>
              <div class="form-group col-12 col-md-4">
                <label class="d-flex align-items-center"><img src="/img/httpssecured.png" alt="Https Secured Icon" style="height: 22px; width: 22px;" class="mr-1"> {{ $t('SEGURIDAD SOCIAL') }}*</label>
                <input v-model="financing.socialSecurity" name="financingForm.socialSecurity" vvalidate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.socialSecurity')">{{ $t('El campo seguridad social es requerido') }}</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <h5 class="col-12 mb-3 formElement">{{ $t('Información del vehículo') }}:</h5>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('VEHÍCULO QUE BUSCA') }} *</label>
                <input v-model="financing.vehicle" name="financingForm.vehicle" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.vehicle')">{{ $t('El campo vehículo es requerido') }}</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="form-group col-12">
                <div class="captcha formBorder">
                  <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                  <label><input v-model="financing.human" name="financingForm.human" v-validate="'required'" type="checkbox"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                  <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                </div>
              </div>
              <div class="col-12">
                <p class="text-success" v-if="financing.responseMessage">{{ $t(financing.responseMessage) }}.</p>
                <button class="btn btn-primary formBackgroundBorder"><i class="icon-send"></i> {{ $t('Enviar') }}</button>
              </div>
            </div>
          </form>

          <form id="trade-tab" :class="{ tab: true, 'd-block': currentTabID == 'trade-tab' }" v-on:submit.prevent="validateForm('tradeInForm')" data-vv-scope="tradeInForm">
            <div class="row">
              <div class="col-12 mt-5 mb-4 my-md-5">
                <h3 class="title text-center">{{ $t('VALOR DE TU TRADE-IN') }}</h3>
              </div>
            </div>
            <div class="row">
              <h5 class="col-12 mb-3 formElement">{{ $t('Información de contacto') }}:</h5>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Nombre').toUpperCase() }} *</label>
                <input v-model="tradeIn.name" name="tradeInForm.name" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.name')">{{ $t('El campo nombre es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Apellido').toUpperCase() }} *</label>
                <input v-model="tradeIn.lastname" name="tradeInForm.lastname" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.lastname')">{{ $t('El campo apellido es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Teléfono').toUpperCase() }} *</label>
                <masked-input v-model="tradeIn.phone" mask="(111) 111-1111" type="tel" name="tradeInForm.phone" v-validate="'required'" class="form-control form-control-lg"/>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="tradeIn.submitted && errors.has('tradeInForm.phone')">{{ $t('El campo teléfono es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Correo Electrónico').toUpperCase() }}</label>
                <input v-model="tradeIn.email" name="tradeInForm.email" v-validate="'email'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.email')">{{ $t('Formato incorrecto') }}</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <h5 class="col-12 mb-3 formElement">{{ $t('Información del vehículo') }}:</h5>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Marca').toUpperCase() }} *</label>
                <input v-model="tradeIn.make" name="tradeInForm.make" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.make')">{{ $t('El campo marca es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Modelo').toUpperCase() }} *</label>
                <input  v-model="tradeIn.model" name="tradeInForm.model" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.model')">{{ $t('El campo modelo es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Año').toUpperCase() }} *</label>
                <input v-model="tradeIn.year" name="tradeInForm.year" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.year')">{{ $t('El campo año es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Millaje').toUpperCase() }} *</label>
                <input v-model="tradeIn.mileage" name="tradeInForm.mileage" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.mileage')">{{ $t('El campo millaje es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('COLOR EXTERIOR') }}</label>
                <input v-model="tradeIn.exteriorColor" name="tradeInForm.exteriorColor" class="form-control form-control-lg" type="text">
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('COLOR INTERIOR') }}</label>
                <input v-model="tradeIn.interiorColor" name="tradeInForm.interiorColor" class="form-control form-control-lg" type="text">
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('Condición').toUpperCase() }} *</label>
                <select v-model="tradeIn.condition" name="tradeInForm.condition" v-validate="'required'" class="form-control form-control-lg">
                  <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                  <option value="excellent">{{ $t('Excelente') }}</option>
                  <option value="good">{{ $t('Buena') }}</option>
                  <option value="regular">{{ $t('Promedio') }}</option>
                  <option value="bad">{{ $t('Bajo promedio') }}</option>
                </select>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.condition')">{{ $t('El campo condición es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-2">
                <label>{{ $t('Fotos del Vehículo').toUpperCase() }}</label>
                <input class="d-none" name="tradeInForm.vehiclePhotos" type="file" id="files" ref="files" accept="image/*" multiple @change="handleFileUpload()"/>
                <div class="row">
                  <button class="btn btn-primary formBackgroundBorder" @click="addFiles()">{{ $t('Añadir fotos') }}</button>
                </div>
              </div>
              <div class="form-group col-12 col-md-6 pt-1">
                <div class="row">
                  <ul class="list-group">
                    <li class="list-group-item" v-for="(file, key) in tradeIn.vehiclePhotos" :key="key" >
                      <img :src="handlePhotoPath(file)" class="img-fluid" style="width: 50px; height: 50px;"/>
                      {{ file.name }} <span class="pl-2 remove-file" @click="removeFile( key )">x</span></li>
                  </ul>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="form-group col-12">
                <div class="captcha formBorder">
                  <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                  <label><input v-model="tradeIn.human" name="tradeInForm.human" v-validate="'required'" type="checkbox"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                  <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('tradeInForm.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                </div>
              </div>
              <div class="col-12">
                <p class="text-success" v-if="tradeIn.responseMessage">{{ $t(tradeIn.responseMessage) }}.</p>
                <button class="btn btn-primary formBackgroundBorder"><i class="icon-send"></i> {{ $t('Enviar') }}</button>
              </div>
            </div>
          </form>

          <form id="ref-tab" :class="{ tab: true, 'd-block': currentTabID == 'ref-tab' }" v-on:submit.prevent="validateForm('referredForm')" data-vv-scope="referredForm">
            <div class="row">
              <div class="col-12 mt-5 mb-4 my-md-5">
                <h3 class="title text-center">{{ $t('REFIERE A TU AMIGO') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('SU NOMBRE').toUpperCase() }}*</label>
                <input v-model="referred.friendName" name="referredForm.friendName" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.friendName')">{{ $t('El campo nombre es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('SU APELLIDO').toUpperCase() }} *</label>
                <input v-model="referred.friendLastname" name="referredForm.friendLastname" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.friendLastname')">{{ $t('El campo apellido es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('SU TELÉFONO').toUpperCase() }} *</label>
                <masked-input v-model="referred.friendPhone" mask="(111) 111-1111" type="tel" name="referredForm.friendPhone" v-validate="'required'" class="form-control form-control-lg"/>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="referred.submitted && errors.has('referredForm.friendPhone')">{{ $t('El campo teléfono es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('SU CORREO ELECTRÓNICO').toUpperCase() }}</label>
                <input v-model="referred.friendEmail" name="referredForm.friendEmail" v-validate="'email'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.friendEmail')">{{ $t('Formato incorrecto') }}</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12 my-4">
                <h3 class="title text-center">{{ $t('TU INFORMACIÓN') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('TU NOMBRE') }} *</label>
                <input v-model="referred.name" name="referredForm.name" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.name')">{{ $t('El campo nombre es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('TU APELLIDO') }} *</label>
                <input v-model="referred.lastname" name="referredForm.lastname" v-validate="'required'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.lastname')">{{ $t('El campo apellido es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('TU TELÉFONO') }} *</label>
                <masked-input v-model="referred.phone" mask="(111) 111-1111" type="tel" name="referredForm.phone" v-validate="'required'" class="form-control form-control-lg"/>
                <span class="text-danger small mb-3 d-block fix-margin" v-if="referred.submitted && errors.has('referredForm.phone')">{{ $t('El campo teléfono es requerido') }}</span>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>{{ $t('TU CORREO ELECTRÓNICO') }}</label>
                <input v-model="referred.email" name="referredForm.email" v-validate="'email'" class="form-control form-control-lg" type="text">
                <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.email')">{{ $t('Formato incorrecto') }}</span>
              </div>
              <div class="form-group col-12 col-md-8">
                <label>{{ $t('COMENTARIO') }}</label>
                <textarea v-model="referred.comments" name="referredForm.comments" class="form-control form-control-lg" rows="1"></textarea>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12 my-4">
                <h3 class="title text-center">{{ $t('ASÍ DE FÁCIL ES') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <div class="whitebox">
                  <span class="formBackgroundBorder"><i class="icon-money"></i></span>
                  <div>
                    <h5 class="formElement">{{ $t('Gana') }}</h5>
                    <p>{{ $t('recomienda_un_amigo', { referral_amount: profile && profile.referral_amount && profile.referral_amount !== '0.00' ? profile.referral_amount : '$!**' }) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="form-group col-12">
                <div class="captcha formBorder">
                  <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                  <label><input v-model="referred.human" name="referredForm.human" v-validate="'required'" type="checkbox"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                  <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('referredForm.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                </div>
              </div>
              <div class="col-12">
                <p class="text-success" v-if="referred.responseMessage">{{ $t(referred.responseMessage) }}.</p>
                <button class="btn btn-primary formBackgroundBorder"><i class="icon-send"></i> {{ $t('Enviar') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <CompareVehicles v-if="isComparingVehicles" :vehicles="selectedVehicles" @toggle="ToggleIsComparingVehicles" @remove="removeSelectedVehicle"/>
    <NavFloating></NavFloating>
    <transition name="zoomDown" tag="div">
      <div class="buy" v-if="selectedVehicles.length > 1">
        <a href="javascript:;" class="btn btn-primary buttonBackgroundBorder" @click="isComparingVehicles = !isComparingVehicles">{{ $t('Comparar') }}</a>
      </div>
    </transition>
  </main>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import vcards from 'vcards-js';
import { saveAs } from 'file-saver';
import MaskedInput from 'vue-masked-input';

require('vue2-animate/dist/vue2-animate.min.css');

export default {
  name: 'home',
  components: {
    Flickity: () => import('vue-flickity'),
    NavFloating: () => import('@/components/NavFloating.vue'),
    VueSlider: () => import('vue-slider-component'),
    CompareVehicles: () => import('@/components/CompareVehicles.vue'),
    MaskedInput,
  },
  data() {
    return {
      isComparingVehicles: false,
      isMounted: false,
      selectedPage: 1,
      selectedFilters: {
        makes: [],
        models: [],
        bodyStyles: [],
        transmissions: [],
        years: [],
        photos: [],
        conditions: [],
        mileages: [],
        priceRange: [0, 100000],
      },
      formatterPrice: v => `$${(` ${v}`).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
      selectedVehicles: [],
      // Vehicle data
      vehicles: [],
      from: 0,
      to: 0,
      vehiclesTotal: 0,
      // Flickity slides
      flickityOptions: {
        initialIndex: 1,
        pageDots: false,
        wrapAround: true,
        lazyLoad: true,
        prevNextButton: false,
      },
      isFilterDisplay: true,
      tabID: 'contact-tab',
      hover: false,
      // Forms
      contact: {
        name: null,
        lastname: null,
        email: null,
        phone: null,
        message: null,
        human: null,
        responseMessage: null,
        submitted: false,
      },
      financing: {
        name: null,
        lastname: null,
        phone: null,
        email: null,
        date: null,
        civilStatus: null,
        address: null,
        urbanization: null,
        city: null,
        zipcode: null,
        jobType: null,
        salary: null,
        residenceType: null,
        residencePayment: null,
        socialSecurity: null,
        vehicle: null,
        human: null,
        responseMessage: null,
        submitted: false,
      },
      tradeIn: {
        name: null,
        lastname: null,
        phone: null,
        email: null,
        make: null,
        model: null,
        year: null,
        mileage: null,
        exteriorColor: null,
        exteriorInterior: null,
        condition: null,
        human: null,
        responseMessage: null,
        vehiclePhotos: [],
        submitted: false,
      },
      referred: {
        friendName: null,
        friendLastname: null,
        friendPhone: null,
        friendEmail: null,
        name: null,
        lastname: null,
        phone: null,
        email: null,
        comments: null,
        human: null,
        responseMessage: null,
        submitted: false,
      },
    };
  },
  watch: {
    selectedFilters: {
      handler() {
        this.setVehicles('filtersChanged');
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['requestVehicles']),
    ...mapMutations(['setTabID']),
    beforeVehicleDetail(vehicleSlug) {
      this.$localStorage.set('selectedFilters', JSON.stringify(this.selectedFilters));
      this.$router.push({ name: 'vehicle-detail', params: { slug: vehicleSlug } });
    },
    setVehicles(flag = null) {
      this.selectedPage = flag === 'filtersChanged' ? 1 : this.selectedPage;
      const payload = { selectedFilters: this.selectedFilters, selectedPage: this.selectedPage };
      this.requestVehicles(payload).then((response) => {
        if (!this.selectedFilters.models.length) this.$store.commit(flag === 'init' ? 'setFilters' : 'setModels', response.data);
        this.from = response.data.from;
        this.to = response.data.to;
        this.vehiclesTotal = response.data.total;
        this.vehicles = flag === 'loadMore' ? [...this.vehicles, ...response.data.data] : response.data.data;
      });
    },
    loadMoreVehicles() {
      this.selectedPage = this.selectedPage + 1;
      this.setVehicles('loadMore');
    },
    removeFilter(index, filter) {
      if (index === 'all') {
        this.selectedFilters.makes = [];
        this.selectedFilters.models = [];
        this.selectedFilters.bodyStyles = [];
        this.selectedFilters.transmissions = [];
        this.selectedFilters.years = [];
        this.selectedFilters.photos = [];
        this.selectedFilters.conditions = [];
        this.selectedFilters.mileages = [];
      } else {
        this.selectedFilters[index] = this.arrayRemove(this.selectedFilters[index], filter);
      }
      this.$localStorage.set('selectedFilters', JSON.stringify(this.selectedFilters));
    },
    arrayRemove(arr, value) {
      return arr.filter(element => element !== value);
    },
    downloadVCF() {
      const userProfile = this.$store.getters.getProfile;
      const sharedData = this.$store.getters.getSharedData;
      const vCard = vcards();
      vCard.firstName = userProfile.first_name;
      vCard.middleName = userProfile.middle_name;
      vCard.title = userProfile.professional_title;
      vCard.organization = sharedData.name;
      vCard.lastName = userProfile.last_name;
      vCard.cellPhone = userProfile.phone;
      vCard.workPhone = sharedData.phone;
      vCard.workAddress.label = 'Work Address';
      vCard.workAddress.street = sharedData.address;
      vCard.email = userProfile.email;
      vCard.photo.attachFromUrl(userProfile.photo_url);
      const file = new File([vCard.getFormattedString()], `${userProfile.first_name.toLowerCase()}-${userProfile.last_name.toLowerCase()}.vcf`, { type: 'text/plain;charset=utf-8' });
      saveAs(file);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        this.contact.submitted = scope === 'contactForm';
        this.financing.submitted = scope === 'financingForm';
        this.tradeIn.submitted = scope === 'tradeInForm';
        this.referred.submitted = scope === 'referredForm';
        if (result && scope === 'contactForm') {
          const formData = new FormData();
          formData.append('name', this.contact.name);
          formData.append('lastname', this.contact.lastname);
          formData.append('phone', this.contact.phone);
          formData.append('email', this.contact.email);
          formData.append('message', this.contact.message);
          formData.append('username', this.$route.params.username);
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/contact`, formData).then((response) => {
            this.contact.responseMessage = response.data;
          });
        }
        if (result && scope === 'financingForm') {
          const formData = new FormData();
          formData.append('name', this.financing.name);
          formData.append('lastname', this.financing.lastname);
          formData.append('phone', this.financing.phone);
          formData.append('email', this.financing.email);
          formData.append('birthdate', this.financing.date);
          formData.append('civilstatus', this.financing.civilStatus);
          formData.append('address', this.financing.address);
          formData.append('urbanization', this.financing.urbanization);
          formData.append('city', this.financing.city);
          formData.append('postalcode', this.financing.zipcode);
          formData.append('employment_type', this.financing.jobType);
          formData.append('monthly_income', this.financing.salary);
          formData.append('residence_owner', this.financing.residenceType);
          formData.append('residence_payment', this.financing.residencePayment);
          formData.append('social_security', this.financing.socialSecurity);
          formData.append('vehicleinfo', this.financing.vehicle);
          formData.append('username', this.$route.params.username);
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/financing`, formData).then((response) => {
            this.financing.responseMessage = response.data;
          });
        }
        if (result && scope === 'tradeInForm') {
          console.log('argarg');
          const formData = new FormData();
          formData.append('name', this.tradeIn.name);
          formData.append('lastname', this.tradeIn.lastname);
          formData.append('phone', this.tradeIn.phone);
          formData.append('email', this.tradeIn.email);
          formData.append('make', this.tradeIn.make);
          formData.append('model', this.tradeIn.model);
          formData.append('year', this.tradeIn.year);
          formData.append('mileage', this.tradeIn.mileage);
          formData.append('exterior_color', this.tradeIn.exteriorColor);
          formData.append('interior_color', this.tradeIn.interiorColor);
          formData.append('condition', this.tradeIn.condition);
          // formData.append('photos', this.tradeIn.vehiclePhotos);
          for (let i = 0; i < this.tradeIn.vehiclePhotos.length; i += 1) {
            const file = this.tradeIn.vehiclePhotos[i];
            formData.append(`photos${i}`, file);
          }
          // console.log(this.tradeIn.vehiclePhotos);
          formData.append('username', this.$route.params.username);
          // this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/tradein`, formData).then((response) => {
          //   this.tradeIn.responseMessage = response.data;
          // });
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/tradein`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then((response) => {
            this.tradeIn.responseMessage = response.data;
          });
        }
        if (result && scope === 'referredForm') {
          const formData = new FormData();
          formData.append('referred_name', this.referred.friendName);
          formData.append('referred_lastname', this.referred.friendLastname);
          formData.append('referred_phone', this.referred.friendPhone);
          formData.append('referred_email', this.referred.friendEmail);
          formData.append('name', this.referred.name);
          formData.append('lastname', this.referred.lastname);
          formData.append('phone', this.referred.phone);
          formData.append('email', this.referred.email);
          formData.append('comment', this.referred.comments);
          formData.append('username', this.$route.params.username);
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/referred`, formData).then((response) => {
            this.referred.responseMessage = response.data;
          });
        }
      });
    },
    toggleFilter() {
      this.isFilterDisplay = !this.isFilterDisplay;
    },
    changeTabID(tabID) {
      this.setTabID(tabID);
    },
    scrollTo(tabID) {
      let id = tabID.substring(1);
      Promise.all([this.setTabID(id)]).then(() => {
        id = tabID === 'finance-tab' || tabID === 'trade-tab' || tabID === 'ref-tab' ? 'contact-tab' : tabID;
        this.$scrollTo(id, 1000, { offset: -180 });
      });
    },
    ToggleIsComparingVehicles(isOpen) {
      this.isComparingVehicles = isOpen;
    },
    removeSelectedVehicle(vehicleId) {
      this.selectedVehicles.splice(this.selectedVehicles.map(item => item.id).indexOf(vehicleId), 1);
    },
    handleFileUpload() {
      const uploadedFiles = this.$refs.files.files;
      for (let i = 0; i < uploadedFiles.length; i += 1) {
        this.tradeIn.vehiclePhotos.push(uploadedFiles[i]);
      }
    },
    handlePhotoPath(file) {
      return URL.createObjectURL(file);
    },
    addFiles() {
      this.$refs.files.click();
    },
    removeFile(key) {
      this.tradeIn.vehiclePhotos.splice(key, 1);
    },
  },
  computed: {
    profile() {
      return this.$store.getters.getProfile;
    },
    filters() {
      return this.$store.getters.getFilters;
    },
    sharedData() {
      return this.$store.getters.getSharedData;
    },
    currentTabID() {
      return this.$store.getters.getTabID;
    },
    // This computed property is used by price range slider
    colorScheme() {
      return this.$store.getters.getColorScheme;
    },
    slides() {
      return this.$store.getters.getBanners;
    },
    checkSelectedFilters() {
      return this.selectedFilters.makes.length || this.selectedFilters.models.length || this.selectedFilters.bodyStyles.length || this.selectedFilters.transmissions.length || this.selectedFilters.years.length || this.selectedFilters.photos.length || this.selectedFilters.conditions.length || this.selectedFilters.mileages.length;
    },
  },
  created() {
    // Assigning selected filters if exists
    if (this.$route.query.redirecting && this.$route.query.redirecting === 'home') {
      this.selectedFilters = this.$localStorage.get('selectedFilters') ? JSON.parse(this.$localStorage.get('selectedFilters')) : this.selectedFilters;
    } else {
      this.$localStorage.remove('selectedFilters');
    }
    // Getting vehicles
    this.setVehicles('init');
    setTimeout(() => {
      this.isMounted = true;
    }, 500);
  },
  mounted() {
    window.addEventListener('unload', this.someMethod);
    if (this.$route.hash) setTimeout(() => { this.$scrollTo(this.$route.hash, 500, { offset: -180 }); }, 1000);
    this.$gtag.event('LandingPageView', {
      event_category: this.profile.email,
      event_label: `${this.profile.first_name} ${this.profile.last_name}`,
    });
  },
};
</script>

<style scoped>
  span.remove-file{
    color: red;
    cursor: pointer;
    padding-top: 11px;
    float: right;
  }
</style>
